import { useState, useEffect, useCallback } from "react";
import Topbar from "../topBar";
import Sidebar from "../sideBar";
import "react-tagsinput/react-tagsinput.css";
import { Link } from "react-router-dom";
import { GET_ROLES, GET_PERMISSIONS, GET_ROLEBYID, MAP_PERMISSIONS } from "../../constants/url";
import {
  Button, FormControl, InputLabel, Select, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Grid,
} from "@mui/material";
import { ERR_GETTING, ERR_POSTING, SUCCESS_SAVE_PERMISSIONS } from "../../constants/alertMessage";
import { privateApiCall } from "../../api/privateApi";
import { toast, Bounce } from 'react-toastify';

const RolePermissions = () => {
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [roleId, setRoleId] = useState("");
  const [roleDetails, setRoleDetails] = useState();

  useEffect(() => {
    fetchRoles();
    fetchPermissions();
  }, []);

  useEffect(() => {
    if (roleId) {
      fetchRoleById();
    }
  }, [roleId]);

  const fetchRoles = async () => {
    try {
      const requestUrl = `${GET_ROLES}`;
      const response = await privateApiCall(requestUrl, "GET");
      setRoles(response.data.roles);
    } catch (error) {
      toast.error(`${ERR_GETTING}`, { transition: Bounce });
    }
  };

  const fetchRoleById = async () => {
    try {
      const requestUrl = `${GET_ROLEBYID}/${roleId}`;
      const response = await privateApiCall(requestUrl, "GET");
      setRoleDetails(response.data);
      setPermissions(response.data.permissions)
    } catch (error) {
      toast.error(`${ERR_GETTING}`, { transition: Bounce });
    }
  };

  const fetchPermissions = async () => {
    try {
      const requestUrl = `${GET_PERMISSIONS}`;
      const response = await privateApiCall(requestUrl, "GET");
      setPermissions(response.data.permissions);
    } catch (error) {
      toast.error(`${ERR_GETTING}`, { transition: Bounce });
    }
  };

  const handleCheckboxChange = (keyword, property) => {
    setPermissions(prevPermissions =>
      prevPermissions.map(permission =>
        permission.keyword === keyword ? { ...permission, [property]: !permission[property] } : permission
      )
    );
  };

  const handleSubmit = useCallback(
    async (event) => {
      const roleData = { roleId: roleId, permissions: permissions }
      event.preventDefault();
      const requestUrl = `${MAP_PERMISSIONS}`;
      try {
        await privateApiCall(requestUrl, "POST", roleData);
        toast.success(`${SUCCESS_SAVE_PERMISSIONS}`, { transition: Bounce });
      } catch (err) {
        toast.error(`${ERR_POSTING}`, { transition: Bounce });
      }
    });

  return (
    <div id="wrapper">
      <Topbar backgroundColor="#769A0F" />
      <Sidebar type="configurations" />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to="/dashboard">Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">Role Permissions</li>
                    </ol>
                  </div>
                  <h4 className="page-title">Role Permissions</h4>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="card-box">
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <InputLabel id="role-label">Select Role</InputLabel>
                    <Select labelId="role-label" value={roleId} onChange={(e) => setRoleId(e.target.value)} required>
                      <MenuItem value=""> <em>Select Role</em> </MenuItem>
                      {roles.map((role) => (<MenuItem key={role.roleId} value={role.roleId}> {role.name} </MenuItem>))}
                    </Select>
                    <Grid container justifyContent="flex-end" sx={{ mt: 3 }}>
                      <Link to="/dashboard"> <Button variant="outlined" color="error" sx={{ mt: 2, mr: 1 }}> Cancel </Button></Link>
                      <Button onClick={handleSubmit} variant="contained" color="success" sx={{ mt: 2 }}
                        style={{ backgroundColor: "#769A0F" }}> Save </Button>
                    </Grid>
                  </FormControl>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="card-box">
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Permissions</TableCell>
                        <TableCell>View</TableCell>
                        <TableCell>Create</TableCell>
                        <TableCell>Edit</TableCell>
                        <TableCell>Delete</TableCell>
                        <TableCell>Feedback</TableCell>
                        <TableCell>Approve</TableCell>
                        <TableCell>Reject</TableCell>
                        <TableCell>Offer</TableCell>
                        <TableCell>Post Product</TableCell>
                        <TableCell>Add Business</TableCell>
                        <TableCell>Request Product</TableCell>
                        <TableCell>Block</TableCell>
                        <TableCell>Unblock</TableCell>
                        <TableCell>Upgrade</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {permissions.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell>{item.title}</TableCell>
                          <TableCell>{item.hasOwnProperty('isView') ?
                            <input type="checkbox" checked={item.isView}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isView") }}
                            /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                          <TableCell>{item.hasOwnProperty('isCreate') ?
                            <input type="checkbox" checked={item.isCreate}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isCreate") }} /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                          <TableCell>{item.hasOwnProperty('isEdit') ?
                            <input type="checkbox" checked={item.isEdit}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isEdit") }} /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                          <TableCell>{item.hasOwnProperty('isDelete') ?
                            <input type="checkbox" checked={item.isDelete}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isDelete") }} /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                          <TableCell>{item.hasOwnProperty('isFeedback') ?
                            <input type="checkbox" checked={item.isFeedback}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isFeedback") }} /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                          <TableCell>{item.hasOwnProperty('isApprove') ?
                            <input type="checkbox" checked={item.isApprove}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isApprove") }} /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                          <TableCell>{item.hasOwnProperty('isReject') ?
                            <input type="checkbox" checked={item.isReject}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isReject") }} /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                          <TableCell>{item.hasOwnProperty('isOffer') ?
                            <input type="checkbox" checked={item.isOffer}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isOffer") }} /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                          <TableCell>{item.hasOwnProperty('isPostProduct') ?
                            <input type="checkbox" checked={item.isPostProduct}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isPostProduct") }} /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                          <TableCell>{item.hasOwnProperty('isAddBusiness') ?
                            <input type="checkbox" checked={item.isAddBusiness}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isAddBusiness") }} /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                          <TableCell>{item.hasOwnProperty('isRequestProduct') ?
                            <input type="checkbox" checked={item.isRequestProduct}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isRequestProduct") }} /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                          <TableCell>{item.hasOwnProperty('isBlock') ?
                            <input type="checkbox" checked={item.isBlock}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isBlock") }} /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                          <TableCell>{item.hasOwnProperty('isUnblock') ?
                            <input type="checkbox" checked={item.isUnblock}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isUnblock") }} /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                          <TableCell>{item.hasOwnProperty('isUpgrade') ?
                            <input type="checkbox" checked={item.isUpgrade}
                              onChange={(e) => { handleCheckboxChange(item.keyword, "isUpgrade") }} /> :
                            <input type="checkbox" disabled checked={false} />}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <Grid container justifyContent="flex-end" sx={{ mt: 3 }}>
                    <Link to="/dashboard"> <Button variant="outlined" color="error" sx={{ mt: 2, mr: 1 }}> Cancel </Button></Link>
                    <Button onClick={handleSubmit} variant="contained" color="success" sx={{ mt: 2 }}
                      style={{ backgroundColor: "#769A0F" }}> Save </Button>
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RolePermissions;